<section class="section-sub-product-hero" *ngIf="_heroData">
  <img
    class="landing-img visible-mobile"
    src="/assets/images/sub-product-wave-mobile.png"
  />
  <div class="container align-c">
    <div class="sub-product-hero-content-box">
      <span class="product-hero-subheading mar-b-16">
        {{ _heroData?.tagName }}
      </span>
      <h1 class="landing-hero-header mar-b-32">
        {{ _heroData?.header }}
      </h1>
      <div
        class="landing-hero-content mar-b-24"
        [innerHtml]="_heroData?.paragraph | toHtml"
      ></div>
      <div class="landing-btn">
        <a
          href="{{ _heroData?.button1?.url | urlParams:queryParams}}"
          target="{{ _heroData?.button1?.target }}"
          class="btn btn-full"
          (click)="onHeroCTAClick()"
          >{{ _heroData?.button1?.text }}</a>
        <app-common-talktosales-button
          [text]="_heroData?.button2?.text"
        ></app-common-talktosales-button>
      </div>
    </div>
    <div class="sub-product-container">
      <div class="sub-product-image">
        <img
          class="landing-img with-height"
          src="{{ _heroData?.image }}"
          alt="{{ _heroData?.alt }}"
        />
      </div>
      <img
        class="landing-img hidden-desktop"
        src="/assets/images/banner-bg.svg"
      />
    </div>
  </div>
</section>
